import {
  SALARY_BONUSES_LOADER,
  GET_SALARY_BONUSES,
  SET_SALARY_BONUSES,
  POST_SALARY_BONUS,
  DELETE_SALARY_BONUS,
  PATCH_SALARY_BONUS,
} from "./actionType";

// Get salary bonuses
export const getBonuses = params => ({
  type: GET_SALARY_BONUSES,
  payload: params,
});

export const setBonuses = data => ({
  type: SET_SALARY_BONUSES,
  payload: data,
});

// Add salary bonus
export const postBonuses = data => ({
  type: POST_SALARY_BONUS,
  payload: data,
});

// Update salary bonus
export const patchBonuses = (id, data) => ({
  type: PATCH_SALARY_BONUS,
  payload: { id, data },
});

// Delete Salary bonus
export const deleteBonuses = id => ({
  type: DELETE_SALARY_BONUS,
  payload: id,
});

// Loader
export const salaryLoader = () => ({
  type: SALARY_BONUSES_LOADER,
});
